<div class="film-cell" (click)="openProgrammeModal(programme().id_reser)">
  <div class="d-flex justify-content-between film-counts mb-1">
    <span>{{ programme().taux }}%</span>
    <span>{{ programme().week_infos.num_semaine }}/{{ programme().week_infos.sem_exploit }}</span>
  </div>
  <div class="film-info">
    <div class="film-name-and-versions">
      <span class="film-name"
            [ngClass]="{'adrc-color': programme().type_copie === 'ADRC',
                        'circ-color': programme().type_copie === 'CIRC',
                        'no-f-color': programme().type_copie === 'NO_F',
                        'pdc-color': programme().type_copie === 'PDC',
                        'apar-color': programme().type_copie === 'APAR',
                        'italic': programme().film_infos.art_essai
            }">
        {{ programme().film_infos.nom_film }}
      </span>
      @if (planningRegionService.hasCommentByDateAndScreenId(data, wednesday, screen().screen_id)) {
        <div class="film-commentaires">
          {{ planningRegionService.getCommentByDateAndScreenId(data, wednesday, screen().screen_id) }}
        </div>
      }
      @if (getVersionsByIdReser(programme().id_reser)) {
        <div class="film-versions">
          Version(s): {{ getVersionsByIdReser(programme().id_reser) }}
        </div>
      }
    </div>
    <div class="badges">
      @if (isAvp(programme())) {
        <span class="badge-icon avp-icon">{{ 'badge.avp' | translate }}</span>
      }
      @if (isSn(programme())) {
        <span class="badge-icon sn-icon">{{ 'badge.sn' | translate }}</span>
      }

    </div>
    <div class="film-edge">
      <i class="bi bi-x-circle-fill remove-icon"
         (click)="removeProgramme($event, programme())"
         [attr.title]="'tooltip.removeWeek' | translate"></i>
    </div>

  </div>

  <div class="d-flex justify-content-start mt-1" style="height: 1.2rem">
    <div class="film-status mx-1">
      <ng-container>
        @switch (programme().statut) {
          @case(6) {
            <i class="bi bi-check-circle-fill text-success"></i>
          }
          @case (5) {
            <i class="bi bi-4-circle-fill blue-icon"></i>
          }
          @case (4) {
            <i class="bi bi-3-circle-fill yellow-icon"></i>
          }
          @case (3) {
            <i class="bi bi-2-circle-fill pink-icon"></i>
          }
          @case (2) {
            <i class="bi bi-1-circle-fill violet-icon"></i>
          }
          @case (1) {
            <i class="bi bi-ban-fill text-danger"></i>
          }
        }
      </ng-container>
    </div>
    @if (isAnnounced(screen().id_cinema)) {
      <span class="announced-icon">A</span>
    }

    @switch (programme().transport) {
      @case ('C') {
        <span class="film-transport mx-1">
                <img ngSrc="../../../../../../../assets/icons/50.png" alt="cinego stock" height="20" width="20">
        </span>
      }
      @case ('D') {
        <i class="film-transport bi bi-hdd-fill mx-1"></i>
      }
    }
  </div>
</div>
